import CongratsBox from './CongratsBox';

export default CongratsBox;
